import React, { useEffect } from 'react';
import ModalWrapper from '../ModalWrapper';

import ModalPersonalDataBody from './ModalPersonalDataBody';

const ModalPersonalData = ({ isOpen, onCloseModal, selectedModel, selectedVersion }) => {

    useEffect(() => {
        if (isOpen) {
            // Guardar el scroll actual
            const scrollY = window.scrollY;
            
            // Aplicar estilos para bloquear scroll
            document.body.classList.add('hide-float-buttons');
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
            
            // Bloquear scroll en el configurador si existe
            const configurator = document.querySelector('.configurator');
            if (configurator) {
                configurator.style.overflow = 'hidden';
                configurator.style.height = '100vh';
            }

            return () => {
                // Restaurar estilos
                document.body.classList.remove('hide-float-buttons');
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.width = '';
                document.body.style.overflow = '';
                
                // Restaurar scroll en el configurador
                if (configurator) {
                    configurator.style.overflow = '';
                    configurator.style.height = '';
                }
                
                // Restaurar posición del scroll
                window.scrollTo(0, scrollY);
            };
        }
    }, [isOpen]);

    return (
        <ModalWrapper isOpen={isOpen} cssClass="modal-personal-data">
            <ModalPersonalDataBody onCloseModal={onCloseModal} selectedModel={selectedModel} selectedVersion={selectedVersion} />
        </ModalWrapper>
    );
}

export default ModalPersonalData;